import styled from "styled-components";

export const StyledRadioInput = styled.input`
  display: none;
  &:checked {
    + .radio-content {
      background-color: var(--primary-color);
      color: var(--white-color);
    }
  }
  + .radio-content:hover {
    background-color: var(--primary-color);
    color: var(--white-color);
    figcaption {
      transition: all 100ms ease;
      transform: translateY(-5px);
    }
  }
`;

export const StyledRadioContent = styled.figure`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  transition: all 250ms ease;
  will-change: transition;
  text-align: center;
  cursor: pointer;
  user-select: none;
  img {
    width: 58px;
    height: 70px;
  }
  background-color: var(--white-color);
  figcaption {
    transition: all 100ms ease;
  }
`;
